@if (devMode.enabled$ | async) {
  <div
    class="dev-mode-badge"
    data-testid="dev-mode-badge"
    role="status"
    aria-label="Development mode active"
    >
    <span class="dev-mode-badge__label">DEV MODE</span>
    <button
      type="button"
      class="dev-mode-badge__close"
      data-testid="dev-mode-badge-close"
      aria-label="Disable development mode"
      (click)="disable()"
    >&times;</button>
  </div>
}
